import { useState, useEffect } from "react";
import axios from "axios";
import { Tag, SlidersHorizontal } from "lucide-react";
import { API } from "./shopData";

/**
 * BrandsForCarBar — toont onderdeel-merken die producten hebben voor de gekozen auto.
 * Sluit in structuur aan bij de bestaande subcategory-pill balk.
 */
export default function BrandsForCarBar({
  carMake,
  carModel,
  engineCode,
  productCategory,
  activeBrand,
  onSelectBrand,
}) {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!carMake) { setBrands([]); return; }
    setLoading(true);
    const params = { car_make: carMake };
    if (carModel) params.car_model = carModel;
    if (engineCode) params.engine_code = engineCode;
    if (productCategory) params.product_category = productCategory;
    axios.get(`${API}/products/brands-for-car`, { params })
      .then((r) => setBrands(r.data || []))
      .catch(() => setBrands([]))
      .finally(() => setLoading(false));
  }, [carMake, carModel, engineCode, productCategory]);

  if (!carMake || (!loading && brands.length <= 1)) return null;

  return (
    <div className="mb-4" data-testid="brands-for-car">
      <div className="flex items-center gap-2 mb-2">
        <Tag size={12} className="text-[#FF3B30]" />
        <span className="text-[10px] text-[#888] uppercase tracking-widest font-bold">
          Merken beschikbaar voor {carMake}{carModel ? ` ${carModel}` : ""}
          {engineCode ? ` · ${engineCode}` : ""}
        </span>
        <span className="text-[#444] text-[10px]">({brands.length})</span>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1.5 scrollbar-hide">
        <button
          onClick={() => onSelectBrand?.(null)}
          data-testid="brands-for-car-all"
          className={`px-3 py-1 rounded-lg text-[11px] font-medium whitespace-nowrap transition-all border flex items-center gap-1.5 ${!activeBrand ? "bg-[#FF3B30]/10 text-[#FF3B30] border-[#FF3B30]/40" : "bg-[#0D0D0D] text-[#666] border-[#1E1E1E] hover:text-white"}`}
        >
          <SlidersHorizontal size={11} /> Alle merken
        </button>
        {brands.map((b) => (
          <button
            key={b.brand}
            onClick={() => onSelectBrand?.(b.brand)}
            data-testid={`brand-for-car-${(b.brand || "").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className={`px-3 py-1 rounded-lg text-[11px] font-medium whitespace-nowrap transition-all border ${activeBrand === b.brand ? "bg-[#FF3B30]/10 text-[#FF3B30] border-[#FF3B30]/40" : "bg-[#0D0D0D] text-[#aaa] border-[#1E1E1E] hover:text-white hover:border-[#FF3B30]/30"}`}
          >
            {b.brand} <span className="text-[#555] font-normal">({b.count})</span>
          </button>
        ))}
      </div>
    </div>
  );
}
